import { createContext, useContext } from 'react';

export const PlatformAccessContext = createContext(null);
export const usePlatformAccess = () => useContext(PlatformAccessContext);
